import { Card } from '@aws-amplify/ui-react';
import { useContext } from 'react';
import { TbHeadset } from 'react-icons/tb';
import { Navigate } from 'react-router-dom';
import { CopyToClipboard } from '../custom-components/CopyToClipboard';
import { GlobalContext } from '../global-context';
import General from '../utils/GeneralUtils';
import './Support.scss';

/** The shared support inbox (HubSpot), where each email becomes a ticket. */
const SUPPORT_EMAIL = 'support@getedulead.com';

/**
 * Support, for paying teams: the support address, large, with a copy button (no mailto: few
 * have a mail client wired to the browser). Trial teams are sent home.
 */
export function Support() {
  const globalContext = useContext(GlobalContext);
  General.setTitle(document, 'Support', globalContext);

  const authInfo = globalContext.authInfo;
  if (authInfo && !General.isPaidTier(authInfo.team?.tier)) return <Navigate to="/" replace />;

  return (
    <div className="content content-1000 support">
      <Card variation="outlined" className="support__card">
        <div className="support__icon">
          <TbHeadset />
        </div>
        <h2 className="support__title">How can we help?</h2>
        <p className="support__lead">
          Questions, problems or ideas: write to our support team. Every email opens a ticket, and
          we reply to the address you write from.
        </p>
        <div className="support__address">
          <span className="support__email">{SUPPORT_EMAIL}</span>
          <CopyToClipboard value={SUPPORT_EMAIL} title="Copy the support address" />
        </div>
      </Card>
    </div>
  );
}
